// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProtocolViewerPanel_Container__Clx1o","Tabs":"ProtocolViewerPanel_Tabs__k5Blu","Tab":"ProtocolViewerPanel_Tab__0wHEc","Panel":"ProtocolViewerPanel_Panel__aCtO_"};